import React, { memo, useState, useEffect, useCallback } from 'react'
import Main from './Main'
import '../../../styles/main.less'
const Index = (props: any) => {
  const [state, setState] = useState('')

  useEffect(() => {

  })

  return (<Main />)
}

export default Index